import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Note } from 'src/app/classes/models';
import { NoteService } from 'src/app/services/note.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-note-display-modal',
  templateUrl: './note-display-modal.component.html',
  styleUrl: './note-display-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NoteDisplayModalComponent implements OnInit {
  constructor(
    private ToastService: ToastService,
    private NoteService: NoteService,
    private ActiveModal: NgbActiveModal,
    private ChangeDetectorRef: ChangeDetectorRef
  ) {}

  @Input() NoteId!: number;
  Note!: Note;

  close() {
    this.ActiveModal.dismiss();
  }

  ngOnInit(): void {
    if (!this.NoteId) {
      throw this.ToastService.addErrorToast('Error', 'Missing note id.', {
        returnError: true
      });
    }

    this.NoteService.getNote({
      id: this.NoteId,
      // This property will be scrubbed for non VIVE-Admin users
      isSensitive: JSON.stringify({
        $or: [true, false]
      })
    }).subscribe({
      next: (Note) => {
        this.Note = Note;
        this.ChangeDetectorRef.markForCheck();
      }
    });
  }
}
